import API from "../../axiosConfig/axiosConfig"
import {
  INVITE_FAILURE,
  INVITE_SUCCESS,
  RESET_INVITE,
  PARTNER_DETAILS_FETCHED,
  SECRETCODE_SUCCESS,
  FAILED_TO_FETCH_PARTNER,
  SET_USER_ONLINE,
  SET_PARTNER_DETAILS,
  PARTNER_VERIFIED,
  PARTNER_DETAILS,
  USER_LOADED,
  INVITE_OPERATION_LOADING,
  REJECTING_INVITE,
  ACCEPTING_INVITE,
} from "../types/types"
import history from "../../history"
import { ENDPOINTS } from "../../constants/apiEndPoints"
import {
  NOTIFICATION_TYPES,
  ToastMessage,
} from "../../components/Notification/Notifications"
import {
  NUDGE_SUCCESS,
  INVITE_SENT,
  NO_DATING_PARTNER,
} from "../../constants/notificationMsg"
import { store } from "../../store"
import _ from "../../utils/lodashUtils"
import { FirebaseService, FIREBASE_STATE_KEYS } from "../../firebase"

// Invite user with email id
// catch block throws error when invited email already exists. Handle it where the action is called
export const inviteByEmail = (
  { inviteeEmail },
  nickName,
  isResendingInvite
) => async (dispatch) => {
  const body = {
    email: inviteeEmail,
    nickname: nickName,
  }
  dispatch({
    type: INVITE_OPERATION_LOADING,
    payload: true,
  })
  try {
    const res = await API.post(ENDPOINTS.INVITE_BY_EMAIL, body, {}, true)

    dispatch({
      type: INVITE_SUCCESS,
      payload: res.data,
      nickName: nickName,
      invitationType: "EMAIL",
      partnerContact: inviteeEmail,
    })
    dispatch({ type: RESET_INVITE })
    FirebaseService.setUserPresence(true, res.data.uuid)
    FirebaseService.setInviteStatus("INACTIVE", res.data.uuid)
    if (isResendingInvite)
      ToastMessage({
        type: NOTIFICATION_TYPES.SUCCESS,
        message: INVITE_SENT(nickName, "email address"),
      })
    dispatch({
      type: INVITE_OPERATION_LOADING,
      payload: false,
    })
    return res
  } catch (err) {
    dispatch({
      type: INVITE_FAILURE,
    })
    dispatch({
      type: INVITE_OPERATION_LOADING,
      payload: false,
    })
    throw err;
  }
}

// Invite user with phone
// catch block throws error when invited phone already exists. Handle it where the action is called
export const inviteByPhone = (
  { inviteeMobile },
  nickName,
  isResendingInvite
) => async (dispatch) => {
  const body = {
    phone: inviteeMobile,
    nickname: nickName,
  }

  try {
    dispatch({
      type: INVITE_OPERATION_LOADING,
      payload: true,
    })
    const res = await API.post(ENDPOINTS.INVITE_BY_PHONE, body, {}, true)

    dispatch({
      type: INVITE_SUCCESS,
      payload: res.data,
      nickName: nickName,
      invitationType: "PHONE",
      partnerContact: inviteeMobile,
    })
    dispatch({ type: RESET_INVITE })
    FirebaseService.setUserPresence(true, res.data.uuid)
    FirebaseService.setInviteStatus("INACTIVE", res.data.uuid)
    dispatch({
      type: INVITE_OPERATION_LOADING,
      payload: false,
    })
    if (isResendingInvite)
      ToastMessage({
        type: NOTIFICATION_TYPES.SUCCESS,
        message: INVITE_SENT(nickName, "phone"),
      })
    return res
  } catch (err) {
    dispatch({
      type: INVITE_FAILURE,
    })
    dispatch({
      type: INVITE_OPERATION_LOADING,
      payload: false,
    })
    throw err;
  }
}

export const resetInvite = () => (dispatch) => {
  dispatch({ type: RESET_INVITE })
}

export const fetchPartnerDetails = () => async (dispatch) => {
  try {
    const response = await API.get(ENDPOINTS.FETCH_PARTNER_DETAILS)

    dispatch({
      type: PARTNER_DETAILS_FETCHED,
      payload: response.data,
    })
    dispatch({
      type: SET_PARTNER_DETAILS,
      payload: response.data,
    })
  } catch (err) {
    dispatch({
      type: FAILED_TO_FETCH_PARTNER,
    })
  }
}

export const invitePartnerToChat = (partnerName, nudgeState) => async (
  dispatch
) => {
  const reqBody = { nudge_stage: nudgeState }
  try {
    const res = await API.post(ENDPOINTS.INVITE_TO_CHAT, reqBody, {})
    const nickName = _.get(store.getState(), "invitePeople.nickName")
    ToastMessage({
      type: NOTIFICATION_TYPES.SUCCESS,
      message: NUDGE_SUCCESS(partnerName || nickName),
    })
  } catch (err) {
    console.error("invite partner to chat error", err)
  }
}

export const secretCodeVerification = ({ secretCode }) => async (dispatch) => {
  const body = JSON.stringify({ invite_code: secretCode })
  const partnerID = _.get(store.getState(), "auth.partner.uuid")
  dispatch({
    type: ACCEPTING_INVITE,
    payload: true,
  })
  try {
    const res = await API.post(
      ENDPOINTS.SECRET_CODE_VERIFICATION,
      body,
      {},
      true
    )
    if (res.data.user_info) {
      dispatch({
        type: SECRETCODE_SUCCESS,
        payload: res.data["dating-info"],
      })
      dispatch({
        type: USER_LOADED,
        payload: res.data.user_info,
      })
      history.push("/dashboard")
      await FirebaseService.setUserPresence(true)
      await FirebaseService.setInviteStatus("ACTIVE")
      dispatch({
        type: ACCEPTING_INVITE,
        payload: false,
      })
    } else
      dispatch({
        type: PARTNER_VERIFIED,
        payload: res.data,
      })
    dispatch({
      type: ACCEPTING_INVITE,
      payload: false,
    })
  } catch (err) {
    dispatch({
      type: ACCEPTING_INVITE,
      payload: false,
    })
    ToastMessage({
      type: NOTIFICATION_TYPES.ERROR,
      message: err.response.data.error,
    })
    if (err.response.data.partner_identifier) {
      dispatch({
        type: PARTNER_DETAILS,
        payload: err.response.data,
      })
      return err.response.data.partner_identifier
    }
  }
  dispatch({
    type: ACCEPTING_INVITE,
    payload: false,
  })
}

export const setUserOnline = () => async (dispatch) => {
  dispatch({
    type: SET_USER_ONLINE,
  })
}

export const rejectInvite = (restaurantId) => async (dispatch) => {
  const body = {
    restaurant_id: restaurantId,
  }
  dispatch({
    type: REJECTING_INVITE,
    payload: true,
  })
  try {
    const res = await API.post(ENDPOINTS.REJECT_INVITE, body)
    FirebaseService.setInviteStatus("REJECTED")
    history.push("/dashboard")
    dispatch({
      type: FAILED_TO_FETCH_PARTNER,
    })
    dispatch({
      type: REJECTING_INVITE,
      payload: false,
    })
  } catch (error) {
    dispatch({
      type: REJECTING_INVITE,
      payload: false,
    })
    console.error(error)
  }
}
